import { PatchShapeType } from "../Data/PatchShapes";

export class QuiltData {
    public readonly patternCount: number;
    public readonly shapes: PatchShapeType[];
    public readonly ramps: PIXI.Point;
    public readonly allowUnique: boolean;
    public readonly allowDecal: boolean;
    public readonly scale: number;

    constructor(pPatternCount: number, pShapes: PatchShapeType[], pRamps: PIXI.Point, pAllowUnique: boolean,
                pAllowDecal: boolean, pScale: number) {
        this.patternCount = pPatternCount;
        this.shapes = pShapes;
        this.ramps = pRamps;
        this.allowUnique = pAllowUnique;
        this.allowDecal = pAllowDecal;
        this.scale = pScale;
    }
}

export const DATA: QuiltData[] = [
    new QuiltData(
        10,
        [
            PatchShapeType.SQUARE_SMALL,
            PatchShapeType.SQUARE_LARGE,
            PatchShapeType.LINE_SMALL,
            PatchShapeType.ELBOW,
        ],
        new PIXI.Point(0, 20),
        true,
        false,
        1 / 0.9,
    ),
    new QuiltData(
        13,
        [
            PatchShapeType.SQUARE_SMALL,
        ],
        new PIXI.Point(20, 25),
        false,
        true,
        1,
    ),
];
